// extracted by mini-css-extract-plugin
export default {"card":"dataBoard_card__4VzTN","dataBoard":"dataBoard_dataBoard__owJPC","dataShow":"dataBoard_dataShow__TS0x-"};